import React from "react";
import { type CompareV2DispatchType, useCompareV2Selector } from "../../redux/store";
import { getCarPriceAndCarIdForEngine } from "../../utils/formatters/priceAndEcoSpecsFormatters";
import PdfLink from "./PdfLink";
import * as CompareStyles from "./styles/CompareStyles";
import * as CompareItemStyles from "./styles/CompareItem";
import * as Text from "../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import Icon from "../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { CompareV2Label } from "../../utils/labels";
import {
    getAEMBuildPage,
    getAEMGradePage,
    getAEMModelPage,
} from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import CompareTable from "../common/CompareTable";
import ButtonPrimary from "../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import ButtonWithIcon from "../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { trackCompareCta } from "../../utils/tracking";
import { showModal } from "../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_DELETE_CAR } from "../../../../shared-logic/features/compare/utils/modalConstants";
import { CompareV2Mode } from "../../../../shared-logic/features/compare/utils/types";
import { useDispatch } from "../../../../shared-logic/redux/store";

const CtaContainer = (): JSX.Element => {
    const dispatch = useDispatch<CompareV2DispatchType>();

    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const selectedEngines = useCompareV2Selector((state) => state.newCarCompare.selectedEngines);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    const carPricesAndCarIds = getCarPriceAndCarIdForEngine(cars, selectedEngines);

    return (
        <>
            <CompareTable
                items={cars}
                columnChild={(car, index) => (
                    <CompareItemStyles.Wrapper>
                        <CompareStyles.Actions>
                            <ButtonPrimary
                                linkWithoutIcon
                                href={
                                    getAEMGradePage(
                                        commonSettings,
                                        car.modelId,
                                        car.colourCode,
                                        carPricesAndCarIds[index].carId,
                                    ) || getAEMModelPage(commonSettings, car.modelId)
                                }
                                onClick={() => trackCompareCta("view-car-details")}
                            >
                                <CompareV2Label label="compareBodyCtaExploreGrade" />
                            </ButtonPrimary>
                            <ButtonSecondary
                                rel="nofollow"
                                linkWithoutIcon
                                href={getAEMBuildPage(
                                    commonSettings,
                                    car.modelId,
                                    car.colourCode,
                                    carPricesAndCarIds[index].carId,
                                    car.availableColours,
                                )}
                                onClick={() => trackCompareCta("carconfigurator")}
                            >
                                <CompareV2Label label="compareBodyCtaPersonalise" />
                            </ButtonSecondary>
                            <ButtonWithIcon
                                hasIconLeft
                                onClick={() => {
                                    dispatch(
                                        showModal({
                                            type: MODAL_DELETE_CAR,
                                            mode: CompareV2Mode.New,
                                            indexToDelete: index,
                                        }),
                                    );
                                }}
                            >
                                <Text.IconButton>
                                    <CompareV2Label label="compareBodyRemoveCar" />
                                </Text.IconButton>
                                <Icon variant="close" />
                            </ButtonWithIcon>
                        </CompareStyles.Actions>
                    </CompareItemStyles.Wrapper>
                )}
            />

            <PdfLink />
        </>
    );
};

export default CtaContainer;
